/** 현장 일정 메일 알림 신청 스위치 — 2026-10-31 Node 「메일 자동 발송은 하지 마」로 닫음. 다시 열 때만 true. */
export const SITE_ALERT_EMAIL_ON = false;
